import { format } from 'date-fns';

/**
 * Firestore hands dates back as Timestamps, but the same fields arrive as Dates
 * or ISO strings depending on where the record has been. One tolerant reader
 * keeps every caller from re-implementing the checks.
 */
export const toMillis = (value: any): number => {
  if (!value) return 0;
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (typeof value.toDate === 'function') return value.toDate().getTime();
  if (value instanceof Date) return value.getTime();
  const parsed = new Date(value).getTime();
  return isNaN(parsed) ? 0 : parsed;
};

export const toDate = (value: any): Date | null => {
  const millis = toMillis(value);
  return millis ? new Date(millis) : null;
};

export const DAY_MS = 24 * 60 * 60 * 1000;

/** The month an invoice belongs to, e.g. "August 2026". */
export const monthLabel = (value: any): string => {
  const date = toDate(value);
  return date ? format(date, 'MMMM yyyy') : 'No date';
};
